import React from 'react';
import ExclamationTriangleIcon from '../halda-design-system/icons/ExclamationTriangleIcon';

interface AppBannerProps {
  title: string;
  message: string;
  buttonUrl: string;
  buttonText: string;
}

const AppBanner = ({
  title, message, buttonUrl, buttonText,
}: AppBannerProps) => (
  <div className="bg-red-100 border-b-2 border-red-200 px-6 py-3" role="alert">
    <div className="flex items-center justify-between">
      <div className="flex flex-row">
        <div className="mr-4 mt-1 bg-white w-12 h-12 p-2 rounded-md border border-red-100 flex items-center justify-center">
          <ExclamationTriangleIcon
            className="h-7 w-7 text-red-600"
          />
        </div>

        <div className="py-1">
          <div className="font-bold text-red-800 mb-1">{title}</div>
          <span className="block sm:inline text-red-600">{message}</span>
        </div>
      </div>
      {buttonUrl && buttonText && (

        <div>
          <a
            target="_blank"
            rel="noreferrer"
            href={buttonUrl}
            className="inline-block text-center px-1 py-2 w-28 rounded text-white bg-red-600"
          >
            {buttonText}
          </a>
        </div>
      )}
    </div>
  </div>
);

export default AppBanner;
